/**
 * UI translations. Each language is one file, public/locales/<code>.json, holding every
 * static string of the app grouped by section (sidebar, myProgress, ...). Only the user's
 * language is downloaded; anything it lacks falls back to English. en.json is the source
 * of truth for keys; translations are edited in the locale files directly.
 *
 * Imported once, from index.tsx. Tests set up their own in-memory instance (setupTests.ts).
 */
import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../utils/languages';
import { storedLanguage } from './language';

document.documentElement.lang = storedLanguage();

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: storedLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES.map((option) => option.code),
    // Codes are plain ('es', 'ja'): never look for 'es-MX' files that don't exist.
    load: 'languageOnly',
    backend: { loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}.json` },
    // React already escapes what it renders.
    interpolation: { escapeValue: false },
  });

export default i18n;
